export default {
  deleteVideoSuccess: 'Successfully deleted video.',
  deleteVideoFailure: 'Could not delete video. Please try again.',
  getVideoFailure: 'Could not find video. Please try again.',
  createEditVideoInvalid: 'You must enter a URL and at least one other field.',
  rickError: 'Cannot load the video due to an invalid URL, but... you got Rick-rolled!',
  getYoutubeVideoDataFailure: 'Unable to Perform YouTube Search. Please try again later.'
}



// WEBPACK FOOTER //
// ./src/videos/messages.js